import { queryClient } from "@/lib/queryClient";
import {
  ACTIVE_TENANT_KEY,
  getActiveTenantId,
  removeLegacyBusinessStorage,
} from "./tenant-browser-storage";

const WORKSPACE_EVENT = "zaytun-soft:workspace-changed";

export function activateWorkspaceBrowserState(
  tenantId: string,
  tenantSlug: string,
): void {
  const previousTenant = localStorage.getItem(ACTIVE_TENANT_KEY);
  if (previousTenant !== tenantId) queryClient.clear();
  removeLegacyBusinessStorage();
  localStorage.setItem(ACTIVE_TENANT_KEY, tenantId);
  localStorage.setItem("workspaceSlug", tenantSlug);
  window.dispatchEvent(
    new CustomEvent(WORKSPACE_EVENT, { detail: { tenantId, tenantSlug } }),
  );
}

export function deactivateWorkspaceBrowserState(): void {
  queryClient.clear();
  removeLegacyBusinessStorage();
  localStorage.removeItem(ACTIVE_TENANT_KEY);
  window.dispatchEvent(new CustomEvent(WORKSPACE_EVENT, { detail: null }));
}

export function destroyClientSession(): void {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  deactivateWorkspaceBrowserState();
}

export { getActiveTenantId };
export const WORKSPACE_CHANGED_EVENT = WORKSPACE_EVENT;
